import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrCF: CultureInfo = {
  name: 'fr-CF',
  displayName: 'français (République centrafricaine)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-CF',
  parent: CultureInfoFr
};
